<template>
  <v-btn class="btn-danger" @click="deleteAll()">解約</v-btn>
</template>

<script>
export default {
  props: {
    routes: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      calcelAllRoute: this.routes.calcelAllRoute,
    };
  },

  methods: {
    deleteAll() {
      if (
        window.confirm(
          "eラーニングのサブスクリプションを解約します。よろしいですか?",
        )
      ) {
        window.location.href = this.calcelAllRoute;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-danger {
  background: #f5f5f5 !important;
  box-shadow: inherit;
  // color: white;
}

@media screen and (max-width: 750px) {
  .v-btn {
    min-width: 60px !important;
    margin: 0 0 0 3px;
  }
}
</style>
